import styled from 'styled-components';
import PanelGroup from 'blocks/PanelGroup/index';

const StyledPanelBody = styled(PanelGroup.Body)`
   width: 100%;
   & p {
    margin: 0;
   }
`;

export default StyledPanelBody;



// WEBPACK FOOTER //
// ./src/kentico-blocks/SimpleAccordion/PanelGroup/StyledPanelBody.jsx